import { danger_color, nitro_color , purple, success_color, theme_color, challenge_color, module_color, custom_light_gray, 
custom_gray, custom_light_blue, custom_dark_gray
} from '@/constants/colors'

require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: nitro_color,
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: success_color,
        info: '#16B1FF',
        warning: '#FFB400',
        error: danger_color,
        nitro: nitro_color,
        module: module_color,
        theme: theme_color,
        challenge: challenge_color,
        purple,
        custom_light_gray,
        custom_gray,
        custom_light_blue,
        custom_dark_gray
      },
    },
  },
}
